import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"

//Include Both Helper File with needed methods
//import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {userResetPasw} from "../../../helpers/backend_helper"

//const fireBaseBackend = getFirebaseBackend()

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
      const response = yield call(userResetPasw, {
        email: user.email,
      })
      if (response) {
        yield put(
          userForgetPasswordSuccess(
            "El link para restablecer tu contraseña fue enviada a tu correo, verifica tu correo"
          )
        )
    }
  } catch (error) {
    yield put(userForgetPasswordError(error))
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
